import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getEmploymentType = async () => {
  const { data } = await axios.get(
    `${api_base_url}/EmployeeConfiguration/EmploymentType`
  );
  return data;
};

export const getEmploymentTypeFilter = async () => {
  const { data } = await axios.get(
    `${api_base_url}/EmployeeConfiguration/EmploymentTypeFilter`
  );

  return data;
};

// Insert New EmploymentType
export const addEmploymentType = async (newEmploymentType) => {
  const { data } = await axios.post(
    `${api_base_url}/EmployeeConfiguration/EmploymentType`,
    {
      ...newEmploymentType[0],
    }
  );
  return data;
};
// Update EmploymentType

export const updateEmploymentType = async (updatedEmploymentType) => {
  const { data } = await axios.put(
    `${api_base_url}/EmployeeConfiguration/EmploymentType${updatedEmploymentType[0].employmentTypeId}`,
    updatedEmploymentType[0]
  );
  return data;
};

export const deleteEmploymentType = async (ids) => {
  await axios.delete(`${api_base_url}/EmployeeConfiguration/EmploymentType`, {
    data: ids,
  });
};
